<div class="backdrop"></div>
<div class="carousel-container" *ngIf="carouselType === 'imagesOnly'">
    <span class="close-button" (click)="closeOverlay()">
        <mat-icon>close</mat-icon>
    </span>
    <div class="carousel-wrapper">
        <carousel [isAnimated]="true" [interval]="0">
            <slide *ngFor="let img of imageList">
                <img [src]="img" class="img-fluid" alt="image">
            </slide>
        </carousel>
    </div>
</div>

<div class="carousel-container" *ngIf="carouselType === 'multimedia'">
    <span class="close-button" (click)="closeOverlay()">
        <mat-icon>close</mat-icon>
    </span>
    <div class="carousel-wrapper">
        <carousel [isAnimated]="true" [interval]="0">
            <slide *ngFor="let item of mediaList">
                <div *ngIf="item.type === 'image'">
                    <img [src]="item.url" class="img-fluid" alt="image">
                </div>
                <div class="pdf-container" *ngIf="item.type === 'pdf'">
                    <iframe [src]="item.url | safeUrl" width="75%" height="450px"></iframe>
                </div>
                <div class="video-container" *ngIf="item.type === 'video'">
                    <video width="75%" height="450" controls>
                        <source [src]="item.url" type="video/mp4">
                        Your browser does not support the video tag.
                    </video>
                </div>
            </slide>
        </carousel>
    </div>
</div>